import { Currency } from '../../../../../../common/types/Currency';

export enum FilterFieldsKeys {
  settlementDateFrom = 'settlementDateFrom',
  settlementDateTo = 'settlementDateTo',
  distributorAgentId = 'distributorAgentId',
  pfhNumber = 'pfhNumber',
  programName = 'programName',
}

export interface FilterFields {
  [FilterFieldsKeys.settlementDateFrom]: string;
  [FilterFieldsKeys.settlementDateTo]: string;
  [FilterFieldsKeys.distributorAgentId]: string;
  [FilterFieldsKeys.pfhNumber]: string;
  [FilterFieldsKeys.programName]: string;
}
